import React, { useState } from "react";
import {
    AppBar,
    Box,
    Button,
    IconButton,
    TextField,
    Toolbar,
    Typography,
    InputAdornment,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";

const ReceiptInput = ({ value, onChange }) => {
    const [textValue, setTextValue] = useState(value?.text || ""); // Текстовое поле
    const [fileValue, setFileValue] = useState(value?.file || null); // Файл
    const navigate = useNavigate();

    // Обработка изменений текстового поля
    const handleTextChange = (e) => {
        const text = e.target.value;
        setTextValue(text);
        if (onChange) {
            onChange({ text, file: null }); // Передаём только текст
        }
        setFileValue(null); // Сбрасываем файл, если вводится текст
    };

    // Обработка выбора файла
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFileValue(file);
        if (onChange) {
            onChange({ text: "", file }); // Передаём только файл
        }
        setTextValue(""); // Сбрасываем текст, если выбран файл
    };

    // Очистка текстового поля
    const handleClearText = () => {
        setTextValue("");
        if (onChange) {
            onChange({ text: "", file: fileValue });
        }
    };

    // Очистка выбранного файла
    const handleClearFile = () => {
        setFileValue(null);
        if (onChange) {
            onChange({ text: textValue, file: null });
        }
    };

    // Сохранение результата
    const handleSave = () => {
        if (onChange) onChange({ text: textValue, file: fileValue });
        navigate(-1); // Возврат назад
    };

    // Возврат назад без сохранения
    const handleBack = () => {
        navigate(-1);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            {/* Верхняя панель */}
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Добавить квитанцию
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Основное содержимое */}
            <Box sx={{ flex: 1, px: 2, pt: 2 }}>
                {/* Поле для ввода текста */}
                <TextField
                    fullWidth
                    disabled={!!fileValue} // Отключаем, если выбран файл
                    value={textValue}
                    onChange={handleTextChange}
                    placeholder="Введите текст..."
                    variant="outlined"
                    InputProps={{
                        endAdornment: textValue && (
                            <InputAdornment position="end">
                                <IconButton onClick={handleClearText}>
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                {/* Кнопка загрузки файла */}
                <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                    <Button
                        variant="contained"
                        component="label"
                        disabled={!!textValue} // Отключаем, если введён текст
                    >
                        Загрузить файл
                        <input
                            type="file"
                            hidden
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                    </Button>
                    {fileValue && (
                        <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
                            <Typography variant="body2" noWrap>
                                {fileValue.name} {/* Отображаем имя файла */}
                            </Typography>
                            <IconButton onClick={handleClearFile}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    )}
                </Box>

                {/* Кнопка сохранения */}
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 4 }}
                    onClick={handleSave}
                    disabled={!textValue && !fileValue} // Отключаем, если ничего не введено или не выбрано
                >
                    Сохранить
                </Button>
            </Box>
        </Box>
    );
};

export default ReceiptInput;
